/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardCreateFromTemplateRequest
 */
export interface DashboardCreateFromTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof DashboardCreateFromTemplateRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCreateFromTemplateRequest
     */
    portfolioKey: string;
}

/**
 * Check if a given object implements the DashboardCreateFromTemplateRequest interface.
 */
export function instanceOfDashboardCreateFromTemplateRequest(value: object): value is DashboardCreateFromTemplateRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('portfolioKey' in value) || value['portfolioKey'] === undefined) return false;
    return true;
}

export function DashboardCreateFromTemplateRequestFromJSON(json: any): DashboardCreateFromTemplateRequest {
    return DashboardCreateFromTemplateRequestFromJSONTyped(json, false);
}

export function DashboardCreateFromTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCreateFromTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'portfolioKey': json['portfolioKey'],
    };
}

export function DashboardCreateFromTemplateRequestToJSON(json: any): DashboardCreateFromTemplateRequest {
    return DashboardCreateFromTemplateRequestToJSONTyped(json, false);
}

export function DashboardCreateFromTemplateRequestToJSONTyped(value?: DashboardCreateFromTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'portfolioKey': value['portfolioKey'],
    };
}

